import * as React from 'react';
import { init, setUser, reactRouterV6Instrumentation, wrapUseRoutes } from '@sentry/react';
import { BrowserTracing } from '@sentry/browser';
import { ExtraErrorData } from '@sentry/integrations';
import { denyUrls, ignoreErrors } from '@moovly/clients';
import { useLocation, useNavigationType, createRoutesFromChildren, matchRoutes, useRoutes } from 'react-router-dom';

export const useSentryRoutes = wrapUseRoutes(useRoutes);
class SentryService {
  init() {
    if (!import.meta.env.PROD) {
      return;
    }
    init({
      integrations: [
        new ExtraErrorData(),
        new BrowserTracing({
          tracePropagationTargets: ['api.moovly.com', /services.moovly.com/, /^\/api/],
          routingInstrumentation: reactRouterV6Instrumentation(
            React.useEffect,
            useLocation,
            useNavigationType,
            createRoutesFromChildren,
            matchRoutes
          ),
        }),
        /* new Replay({
          // Additional SDK configuration goes in here, for example:
          maskAllText: true,
          blockAllMedia: true,
        }),*/
      ],

      dsn: 'https://81a83ab97d9e4a7d914fb52e27c42f71@o101602.ingest.sentry.io/1326844',
      release: import.meta.env.MOOVLY_APP_RELEASE_VERSION,
      ignoreErrors: [...ignoreErrors],
      denyUrls: [...denyUrls, /e.clarity.ms/i],
    });
  }
  setUser(userId: string) {
    setUser({ id: userId });
  }
}
export default new SentryService();
